import { useTranslation } from 'react-i18next';

import { ContactTabSectionHeading } from '~/scenes/PeopleModule/components/Tabs/ContactTab/components/ContactTabSectionHeading';
import { ContactTabSectionAccess } from '~/scenes/PeopleModule/components/Tabs/ContactTab/useContactTab';
import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';

import { EmergencyContactEditMode } from './components/EmergencyContactEditMode';
import { EmergencyContactReadMode } from './components/EmergencyContactReadMode';
import { useEmergencyContact } from './useEmergencyContact';

export const EmergencyContact = (props: ContactTabSectionAccess) => {
  const { canEdit } = props;

  const { form, actions, empData, readMode, isLoading } = useEmergencyContact();
  const { t } = useTranslation();

  if (isLoading) {
    return <LoadingView />;
  }

  return (
    <>
      <ContactTabSectionHeading
        heading={t('laEme')}
        canEdit={canEdit}
        readMode={readMode}
        {...actions}
      />
      {readMode ? (
        <EmergencyContactReadMode data={empData} />
      ) : (
        <EmergencyContactEditMode form={form} />
      )}
    </>
  );
};
